import React, { Dispatch, SetStateAction } from "react";

import {
  DeactivateEmployeeModal,
  AssignEmployeeToPropertiesModal,
} from "manager/components/Modal";
import ResendEmployeeInviteModal from "manager/components/Modal/ResendEmployeeInviteModal/ResendEmployeeInviteModal";
import { Employee } from "manager/interfaces/api/employee";
import useModal from "shared/hooks/useModal";
import usePermissions from "shared/hooks/usePermissions";
import { Pagination } from "shared/interfaces";

import {
  AssignEmployeeToPropertyParams,
  DeactivateEmployeeParams,
} from "../interface";

import EmployeesTable from "./EmployeesTable";

interface EmployeesTableContainerProps {
  employees: Employee[];
  loading: boolean;
  employeesCount: number;
  hasInputValue: boolean;
  pagination: Pagination;
  setPagination: Dispatch<SetStateAction<Pagination>>;
  showDeactivated?: boolean;
}

const EmployeesTableContainer = ({
  employees,
  loading,
  employeesCount,
  hasInputValue,
  pagination,
  setPagination,
  showDeactivated = false,
}: EmployeesTableContainerProps) => {
  const { openModalDialog } = useModal();
  const { canInviteEmployee } = usePermissions();
  const canResendEmployeeInvite = canInviteEmployee;

  const deactivateEmployee = ({ employeeId, name }: DeactivateEmployeeParams) =>
    openModalDialog(DeactivateEmployeeModal, {
      employeeId,
      name,
    });
  const assignEmployeeToProperty = ({
    employeeId,
    firstName,
    lastName,
  }: AssignEmployeeToPropertyParams) =>
    openModalDialog(AssignEmployeeToPropertiesModal, {
      employeeId,
      firstName,
      lastName,
    });

  const resendEmployeeInviteOpen = (employee: Employee) =>
    openModalDialog(ResendEmployeeInviteModal, { employee });

  return (
    <EmployeesTable
      employees={employees}
      loading={loading}
      employeesCount={employeesCount}
      hasInputValue={hasInputValue}
      pagination={pagination}
      setPagination={setPagination}
      deactivateEmployee={deactivateEmployee}
      assignEmployeeToProperty={assignEmployeeToProperty}
      resendEmployeeInvite={resendEmployeeInviteOpen}
      canResendEmployeeInvite={canResendEmployeeInvite}
      showDeactivated={showDeactivated}
    />
  );
};

export default EmployeesTableContainer;
